import React, {useEffect, useRef, useState} from "react";
import { getGutterWidth } from "../../globals/helpers";
import { motion } from "framer-motion";

const CornerHover = ({customCornerSize = null, cornerDurationTime = null, bezierFunc = "cubic-bezier(0, 0.55, 0.45, 1)", isActive=false, isSelected=null, performInitial=null, counterYScaler=null}) => {
    const horizRefs = useRef([]);
    const vertRefs = useRef([]);

    useEffect(() => {
        if(isSelected){
            if(horizRefs.current){
                for(let i=0; i< horizRefs.current.length; i++){
                    horizRefs.current[i].style.transform = "scale(0, 1)"
                    horizRefs.current[i].style.transition = "0.5s ease"
                }
            }

            if(vertRefs.current){
                for(let i=0; i< vertRefs.current.length; i++){
                    vertRefs.current[i].style.transform = "scale(1, 0)"
                    vertRefs.current[i].style.transition = "0.5s ease"
                }
            }
        }
    }, [isSelected])

    const tlVariants = {
        initial: {
            
        }, animate: {
        }
    }

    const trVariants = {
        initial: {
            transform: ""
        }, animate: {
        }
    }

    const blVariants = {
        initial: {
            transform: ""
        }, animate: {
        }
    }

    const brVariants = {
    }

    const scalerVariants = {
    }

    return(
        <>
            <div className={`bc_wrapper ${isActive ? 'item-hov' : ''}`}>
                <div className="left">
                    <motion.div 
                        className="t"
                        style={{
                            width: customCornerSize ? customCornerSize["width"] : '',
                            height: customCornerSize ? customCornerSize['height'] : '',
                            transition: "transform 1s cubic-bezier(0.16, 1, 0.3, 1);"
                        }}
                        initial="initial"
                        animate={isSelected ? "animate" : "initial"}
                        exit="exit"
                        variants={tlVariants}
                    >
                        <motion.div 
                            className="h"
                            style={{transition: cornerDurationTime ? "transform " + cornerDurationTime + "s "+bezierFunc : ''}}
                            variants={scalerVariants}
                            ref={el => horizRefs.current[0] = el}
                            custom={true}
                        />
                        <motion.div className="v"
                            style={{transition: cornerDurationTime ? "transform " + cornerDurationTime + "s "+bezierFunc : ''}}
                            variants={scalerVariants}
                            ref={el => vertRefs.current[0] = el}
                            custom={false}
                        />
                    </motion.div>
                    <motion.div 
                        className="b"
                        style={{
                            width: customCornerSize ? customCornerSize["width"] : '',
                            height: customCornerSize ? customCornerSize['height'] : ''
                        }}
                        initial="initial"
                        animate={isSelected ? "animate" : "initial"}
                        exit="exit"
                        variants={blVariants}
                    >
                        <motion.div className="h"
                            style={{transition: cornerDurationTime ? "transform " + cornerDurationTime + "s "+bezierFunc : ''}}
                            variants={scalerVariants}
                            ref={el => horizRefs.current[1] = el}
                            custom={true}
                        />
                        <motion.div className="v"
                            style={{transition: cornerDurationTime ? "transform " + cornerDurationTime + "s "+bezierFunc : ''}}
                            variants={scalerVariants}
                            ref={el => vertRefs.current[1] = el}
                            custom={false}
                        />
                    </motion.div>
                </div>
                <div className="right">
                    <motion.div 
                        className="t"
                        style={{
                            width: customCornerSize ? customCornerSize["width"] : '',
                            height: customCornerSize ? customCornerSize['height'] : ''
                        }}
                        initial="initial"
                        animate={isSelected ? "animate" : "initial"}
                        variants={trVariants}
                    >
                        <motion.div className="h"
                            style={{transition: cornerDurationTime ? "transform " + cornerDurationTime + "s "+bezierFunc : ''}}
                            variants={scalerVariants}
                            ref={el => horizRefs.current[2] = el}
                            custom={true}
                        />
                        <motion.div className="v"
                            style={{transition: cornerDurationTime ? "transform " + cornerDurationTime + "s "+bezierFunc : ''}}
                            variants={scalerVariants}
                            ref={el => vertRefs.current[2] = el}
                            custom={false}
                        />
                    </motion.div>
                    <motion.div 
                        className="b"
                        style={{
                            width: customCornerSize ? customCornerSize["width"] : '',
                            height: customCornerSize ? customCornerSize['height'] : ''
                        }}   
                        initial="initial"
                        animate={isSelected ? "animate" : "initial"}
                        variants={brVariants} 
                    >
                        <motion.div className="h"
                            style={{transition: cornerDurationTime ? "transform " + cornerDurationTime + "s )"+bezierFunc : ''}}
                            variants={scalerVariants}
                            ref={el => horizRefs.current[3] = el}
                            custom={true}
                        />
                        <motion.div className="v"
                            style={{transition: cornerDurationTime ? "transform " + cornerDurationTime + "s "+bezierFunc : ''}}
                            variants={scalerVariants}
                            ref={el => vertRefs.current[3] = el}
                            custom={false}
                        />
                    </motion.div>
                </div>
            </div>
        </>
    )
}

export default CornerHover